<template>
  <b-row>
    <b-col>
      <TechnicianForDispatcher></TechnicianForDispatcher>
    </b-col>
  </b-row>
</template>

<script>
import TechnicianForDispatcher from './components/show/TechnicianForDispatcher'
export default {
  name: 'Show',
  components: {
    TechnicianForDispatcher
  }
}
</script>
